import React, { useEffect, useState } from 'react';
import { Container, Form, Col, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { mixed, object, string } from 'yup';
import { useForm } from 'react-hook-form/dist/react-hook-form.ie11';
import { CheckboxInput, RadioInput, SelectInput, TextInput } from '../../../Helpers/Inputs';
import Button from '@material-ui/core/Button';
import Calendar from '../../../../icons/calendar.svg';
import SvgIcon from '@material-ui/core/SvgIcon';
import timeZones from '../../../Quoters/Common/Appointment/Timezones';
import moment from 'moment-timezone';
import Scheduler from '../../../Quoters/Common/Appointment/Scheduler';
import BusinessHours from '../../../Quoters/Common/Appointment/BusinessHours'
import { emptyStringToUndefined } from '../../../Helpers/Formatters/EmptyStringToUndefined.js';
import RequestSummary from '../../SharedComponents/SubComponents/RequestSummary';
import { httpRequest } from '../../../../httpRequest';
import { ADVISOR_OBJECT_KEY, getSessionStorageItem, setSessionStorageItem } from '../../../../sessionStorage';
import { CircularProgress } from '@material-ui/core';
import { requestBody } from "./requestBody";
import PremiumMode from './PremiumMode';
import { InputMaskPhone, GetFormattedNumber } from '../../../Helpers/Formatters';
import GetOwnerDetails from '../../Common/GetOwnerDetails';
import getUnviewedNotification from '../../../Notifications/SubComponents/UnviewedNotification';
import useUserInfo from '../../../../hooks/useUserInfo';
import { OneClickProductType } from '../../../Common/Constant.js';
import '../../CreateCase/CreateCase.scss';

export default function YourInformation(props) {

  const { register, errors, handleSubmit, setValue, triggerValidation } = useForm({
    validationSchema: YourInformation.ValidationSchema(props.isPermIllustration,props.isIllustration),
    mode: 'onBlur',
    reValidateMode: 'onBlur',
  });

  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [advisorEmailOption, setAdvisorEmailOption] = useState([]);
  const [clientEmailOption, setClientEmailOption] = useState([]);
  const [clientPhoneOption, setClientPhoneOption] = useState([]);
  const [advisorPhoneOption, setAdvisorPhoneOption] = useState([]);
  const {setNotificationCount} = useUserInfo();
  const isSubmitCase = props.isSubmitCase || false;
  let productInfo;
  const insuredInfo = props.basicInfo && props.basicInfo.pages.insuredBasicInfo ? (props.oneClickProductType === OneClickProductType.MorganStanleyLTCQ ? props.basicInfo.pages.insuredBasicInfo.insuredInfo[0] : props.basicInfo.pages.insuredBasicInfo) : '';
  const clientInfo = props.basicInfo && props.basicInfo.pages.clientType ? props.basicInfo.pages.clientType : '';
  const requestSummary = props.basicInfo && props.basicInfo.pages.requestSummary ? props.basicInfo.pages.requestSummary : '';
  const retrieveAccountInfo = props.basicInfo && props.basicInfo.pages.retrieveAccount;
  const piIsOwner = (retrieveAccountInfo && retrieveAccountInfo.isProposedInsured === 'true' && !props.isSurvivorshipPolicy) || (props.isSurvivorshipPolicy && retrieveAccountInfo && retrieveAccountInfo.insured && retrieveAccountInfo.insured !== "Other");
  let agentInfo;
  if (props.isCaseSubmit) {
    const product = props.basicInfo && props.basicInfo.pages.quoteDetail ? props.basicInfo.pages.quoteDetail : '';
    const productAmount = props.basicInfo && props.basicInfo.pages.proposedInsurance ? props.basicInfo.pages.proposedInsurance : '';
    productInfo = {
      healthClass: product.healthClass || '',
      product: product.product,
      carrierName: product.carrier,
      term: product.term || product.GuaranteedDeathBenefit,
      coverageAmount: product.premiumPaid || product.premiumAmount,
      premium: '',
      annualPremium: productAmount.annualPremium,
      carrierID: ''
    }
    agentInfo = props.basicInfo && props.basicInfo.pages.selectAgent ? props.basicInfo.pages.selectAgent : '';
  } else {
    // Term Life
    productInfo = props.product ? props.product : '';
    agentInfo = props.agentInfo;
  }

  useEffect(() => {
    register({ name: 'specificApptDate' });
    setValue('specificApptDate', props.formState.specificApptDate);

    register({ name: 'specificApptTime' });
    setValue('specificApptTime', props.formState.specificApptTime);

    register({ name: 'timeZone' });
    setValue('timeZone', props.formState.timeZone);

    register({ name: 'attestation' });
    setValue('attestation', props.formState.attestation);

    register({ name: 'advEmail' });
    setValue('advEmail', props.formState.advEmail)

    register({ name: 'clientEmail' });
    setValue('clientEmail', props.formState.clientEmail)

    register({ name: 'clientPhone' });
    setValue('clientPhone', props.formState.clientPhone)

    register({ name: 'altEmail' });
    setValue('altEmail', props.formState.altEmail)

  }, [register])

  const handleValueChange = (field, value) => {
    if (field === 'specificApptDate') {
      let fullForm = { ...props.basicInfo }
      fullForm.pages.yourInformation.specificApptDate = value;
      fullForm.pages.yourInformation.specificApptTime = '';
      props.onMultiFieldChange(fullForm);
      setValue('specificApptTime', '');
    }
    else {
      props.onFieldChange(field, value);
    }
    setValue(field, value);
    triggerValidation(field);
  };

  useEffect(() => {
    getAdvisorData();
    calculateNegativeCashFunding();
  }, [])

  const getAdvisorData = () => {
    let fullForm = { ...props.basicInfo }
    let licenseCheck = props.basicInfo.pages.retrieveAccount.clientData && props.basicInfo.pages.retrieveAccount.clientData.licenseCheckResponse;
    let faDetails = licenseCheck && licenseCheck.quoteFAList && licenseCheck.quoteFAList && licenseCheck.quoteFAList.length > 0 && licenseCheck.quoteFAList.find(x => x.primary === true);
    const clientDetail= GetOwnerDetails(fullForm);
    const emailOptions = [];
    const phoneOptions = [];
    if (faDetails.repAgentEmail) {
      emailOptions.push({ value: faDetails.repAgentEmail, label: faDetails.repAgentEmail });
    }
    else{
      emailOptions.push({value :'altEmail' ,label:'Alternate Email'})
    }
    if(faDetails.repAgentPhone){
      const formattedPhone = GetFormattedNumber(faDetails.repAgentPhone)
      phoneOptions.push({ value: formattedPhone, label: formattedPhone });
    }
    else{
      phoneOptions.push({value :'altPhone' ,label:'Alternate Phone'})
    }
    setAdvisorPhoneOption(phoneOptions);
    setValue('advPhone', phoneOptions[0].value);
    setAdvisorEmailOption(emailOptions);
    setValue('advEmail', emailOptions[0].value);
    fullForm.pages.yourInformation.advEmail = emailOptions[0].value;
    fullForm.pages.yourInformation.advPhone = phoneOptions[0].value;

    if (clientDetail && piIsOwner) {
      let clientEmails = Object.keys(clientDetail).filter(data => data.toLowerCase().includes('email') && clientDetail[data]);
      let clientPhones = Object.keys(clientDetail).filter(data => data.toLowerCase().includes('phone') && clientDetail[data]);
      clientEmails.map(data => clientDetail[data]).forEach((element, index) => {
        setClientEmailOption((r) => [...r, { label: element, value: element }])
      });
      clientPhones.map(data => clientDetail[data]).forEach((element, index) => {
        setClientPhoneOption((r) => [...r, { label: GetFormattedNumber(element), value: element }])
      });
    }
    else{
      setValue('clientEmail', fullForm.pages.insuredBasicInfo.proposedInsuredEmail);
      fullForm.pages.yourInformation.clientEmail = fullForm.pages.insuredBasicInfo.proposedInsuredEmail;
      setValue('clientPhone', fullForm.pages.insuredBasicInfo.proposedInsuredPhone);
      fullForm.pages.yourInformation.clientPhone = GetFormattedNumber(fullForm.pages.insuredBasicInfo.proposedInsuredPhone);
    }
    props.onMultiFieldChange(fullForm);
  }

  const calculateNegativeCashFunding = () => {
    const basicInfo = {...props.basicInfo};
    if (props.productType === 'SUBMIT_ILLUSTRATION') {
      const applicationInformation = basicInfo.pages.applicationInformation;
      const selectProduct = basicInfo.pages.selectProduct;
      if (applicationInformation && applicationInformation.replacement === 'yes' && applicationInformation.sourceOfFunds === 'ExchangeOrReplacement')
      {
        const exchangeLumpSum = Number(applicationInformation.exchangeLumpSum);
        const showPermError = selectProduct && selectProduct.firstYearPremium && exchangeLumpSum > Number(selectProduct.firstYearPremium);
        const showLTCError = selectProduct && selectProduct.premium && selectProduct.premiumMode && exchangeLumpSum > (Number(selectProduct.premium) / PremiumMode(selectProduct.premiumMode))
        if ( showPermError || showLTCError ) {
          showNegativeCashFunding(false);
          return false;
        }
      }
    } else if (props.isTerm) {
      const coverageAmount = props.selectedQuote ? props.selectedQuote.coverageAmount : null;
      const premium = Number(basicInfo.pages.quoter.premium)
      const premiumAmount = basicInfo.pages.quoter.premiumAs === 'monthly' ? premium*12 : premium ;
      if (coverageAmount !== null) {
        const applicationInformation = basicInfo.pages.applicationInformation;

        if (applicationInformation && applicationInformation.replacement === 'yes' && applicationInformation.sourceOfFunds === 'ExchangeOrReplacement') {
          const exchangeLumpSum = Number(applicationInformation.exchangeLumpSum);
          if (exchangeLumpSum > coverageAmount || exchangeLumpSum > premiumAmount) {
            showNegativeCashFunding(true);
            return false;
          }
        }
      }
    }

    return true;
  }

  const showNegativeCashFunding = (isTerm) => {
    window.scroll(0,0);
    const goBackStatement = isTerm ? "Please go back and increase the Coverage Amount." : "Please go back and increase the First Year Premium value.";
    setErrorMessage(`Cash funding value shouldn't be negative. ${goBackStatement}`);
  };

  const onSubmit = () => {
    const basicInfo = {...props.basicInfo};
    if (!calculateNegativeCashFunding()) {
      return;
    }

    setLoading(true);

    basicInfo.pages.yourInformation.advisorEmail = props.formState.advEmail === 'altEmail' ? props.formState.altEmail : props.formState.advEmail;
    basicInfo.pages.yourInformation.advisorPhone = props.formState.advPhone === 'altPhone' ? props.formState.altPhone : props.formState.advPhone;
    const userData = getSessionStorageItem(ADVISOR_OBJECT_KEY);
    const requestData = requestBody(props.productType, basicInfo, userData, props.oneClickProductType, props.showAttestation);

    httpRequest.post(`/api/Case/Submit`, requestData, props.productType)
      .then((data) => {
        let fullForm = { ...props.basicInfo }
        if (data.success) {
          getUnviewedNotification().then((count)=>{
            let advisorObj = getSessionStorageItem(ADVISOR_OBJECT_KEY);
            advisorObj.unviewedNotificationCount = count;
            setSessionStorageItem(ADVISOR_OBJECT_KEY,advisorObj);
            setNotificationCount(count);
          })
          fullForm.pages.yourInformation.caseID = data.content.morganStanleyQuoteId;
          fullForm.pages.yourInformation.referenceID = data.content.referenceId;
          if (!props.isIllustration) {
            if (data.content.morganStanleyTicketErrorMessages !== null && data.content.morganStanleyTicketErrorMessages.length > 0) {
              fullForm.pages.yourInformation.morganStanleyTicketErrorMessages = data.content.morganStanleyTicketErrorMessages;
              fullForm.pages.yourInformation.isQuoteFailure = true;
            }
            else {
              fullForm.pages.yourInformation.caseNumber = data.content.caseNumber;
              fullForm.pages.yourInformation.isQuoteFailure = false;
            }
          }
          props.onMultiFieldChange(fullForm);
          props.onNext();
        }
        setLoading(false);
      }).catch((err) => {
        setErrorMessage(err);
        setLoading(false);
      });
  }

  return (
    <Container fluid className="appointment-information-box border-class ">
      <form onSubmit={handleSubmit(onSubmit)}>
        <Row>
          <RequestSummary
            isTerm={props.isTerm}
            selectedQuote={props.selectedQuote}
            isSPWL={props.isSPWL || false}
            finalSummary={props.finalSummary}
            productInfo={productInfo}
            insuredInfo={insuredInfo}
            clientInfo={clientInfo}
            agentInfo={agentInfo}
            requestSummary={requestSummary}
            data={props}
            isSubmitCase={isSubmitCase}
            isSurvivorshipPolicy={props.isSurvivorshipPolicy}
            isDICreateCase={props.isDICreateCase}
          />
          <Col md={5} className='px-5'>
            <div className='pl-3'>
              <div className="text-center mb-3 mt-4">
                <SvgIcon id="calender-icon" color="primary" className="iconsSvg" component={Calendar} />
              </div>
              {errorMessage !== '' &&
                <div className="warning-message alert alert-danger mt-4" >
                  {errorMessage}
                </div>
              }
              {props.isTerm &&
                <div>
                  <div className="row">
                    <div className="col-sm-12">
                      <h4 id="term-info-header" className='info-heder'>Important Information Regarding This Submission</h4>
                      <ul>
                      <li id="term-info-list-item-one">Please only submit one client at a time</li>
                      <li id="term-info-list-item-two">Please ensure that you have communicated the exact quote above to your client</li>
                      <li id="term-info-list-item-three">If the quote or product desired by the client changes substantially from the request, the client will be sent back to you for a new quote</li>
                      </ul>
                    </div>
                  </div>
                  <Form.Group>
                    <CheckboxInput
                      name="attestation"
                      id="attestation"
                      label="Attestation: I have assessed and determined that this Insurance solution is consistent with the client’s investment objectives, risk tolerance, and financial situation."
                      checked={props.formState.attestation}
                      onChange={e => handleValueChange('attestation', e.target.checked)}
                      errors={errors.attestation}
                      inputRef={register}
                      color="primary"
                      className="attestation"
                      labelClassName="setCheckBox"
                    />
                  </Form.Group>
                </div>
              }
              <h4 id="appointment-selection-header" className=" text-center mb-2"><b>Select an Appointment</b></h4>
              {!props.isPermIllustration && <div id="appointment-confirmation-header" className="appointment-confirmation mb-2"><b>Thank you for submitting your request. One of our product specialists will contact you as requested.</b></div>}
              {!props.isTerm && !props.isPermIllustration && !props.isIllustration ? <Form.Group>
                <CheckboxInput
                  name="attestation"
                  id="attestation"
                  label="Attestation: I have assessed and determined that this Insurance solution is consistent with the client’s investment objectives, risk tolerance, and financial situation."
                  checked={props.formState.attestation}
                  onChange={e => handleValueChange('attestation', e.target.checked)}
                  errors={errors.attestation}
                  inputRef={register}
                  color="primary"
                  className="attestation"
                  labelClassName="setCheckBox"
                />
              </Form.Group> : ""}
              <Form.Group className="specificAppt">
                <RadioInput
                  name="specificAppt"
                  id="specificAppt"
                  label={props.isPermIllustration ? 'When Should We Contact You?' : 'If preferred, select a date and time that works best for your client.'}
                  value={props.formState.specificAppt}
                  radios={[{ value: "asap", label: `${props.isPermIllustration ? 'As Soon As Possible' : 'Contact your client within 3 business days'}` }, { value: "schedule", label: `${props.isPermIllustration ? 'Specific Appointment' : "Select Date/Time for a phone call to your client"}` }]}
                  onChange={e => handleValueChange('specificAppt', e.target.value)}
                  errors={errors.specificAppt}
                  inputRef={register}
                />
              </Form.Group>
              {props.formState.specificAppt === 'asap' &&
                <BusinessHours />
              }
              <Scheduler
                hide={props.formState.specificAppt !== 'schedule'}
                register={register}
                errors={errors}
                timeZone={props.formState.timeZone}
                apptDate={props.formState.specificApptDate}
                apptTime={props.formState.specificApptTime}
                setTimeZone={(e) => handleValueChange('timeZone', e)}
                setApptDate={(e) => handleValueChange('specificApptDate', e)}
                setApptTime={(e) => handleValueChange('specificApptTime', e)}
                hideBackground={true}
                appointmentTimeSelectEnabled={true}
              />
              {props.isPermIllustration &&
                <div>
                  <p id="advisor-contact-selection-header" className=''>Please select the preferred Financial Advisor contact information to be used during the application process.</p>
                  <Form.Group>
                    <SelectInput
                      name="advPhone"
                      id="advPhone"
                      value={props.formState.advPhone}
                      onChange={(e) => handleValueChange('advPhone', e.target.value)}
                      label="Financial Advisor Phone"
                      selectOptions={advisorPhoneOption}
                      errors={errors.advPhone}
                      inputRef={register}
                    />
                  </Form.Group>
                  {props.formState.advPhone === 'altPhone' &&
                    <Form.Group>
                      <TextInput
                        name="altPhone"
                        id="altPhone"
                        value={props.formState.altPhone}
                        onChange={e => handleValueChange('altPhone', e.target.value)}
                        label="Alternate Phone"
                        errors={errors.altPhone}
                        inputRef={register}
                        InputProps={{
                          inputComponent: InputMaskPhone,
                        }}
                      />
                    </Form.Group>
                  }
                    <Form.Group>
                    <SelectInput
                      name="advEmail"
                      id="advEmail"
                      value={props.formState.advEmail}
                      onChange={(e) => handleValueChange('advEmail', e.target.value)}
                      label="Financial Advisor Email"
                      selectOptions={advisorEmailOption}
                      errors={errors.advEmail}
                      inputRef={register}
                    />
                  </Form.Group>
                  {
                    props.formState.advEmail === 'altEmail' &&
                   <Form.Group>
                     <TextInput
                    name="altEmai"
                    id="altEmail"
                    value={props.formState.altEmail}
                    onChange={e => handleValueChange('altEmail', e.target.value)}
                    label="Alternate Email Address"
                    errors={errors.altEmail}
                    inputRef={register}
                  />
                   </Form.Group>
                  }
                </div>
              }
              {!props.isIllustration && !props.isPermIllustration &&
               <React.Fragment>
                  <p id="client-contact-selection-header">Please select the preferred client contact information to be used during the application process.</p>
                  {piIsOwner ?
                    <React.Fragment>
                      <Form.Group>
                        <SelectInput
                          name="clientPhone"
                          id="clientPhone"
                          value={props.formState.clientPhone}
                          onChange={(e) => handleValueChange('clientPhone', e.target.value)}
                          label="Client Phone"
                          selectOptions={clientPhoneOption}
                          errors={errors.clientPhone}
                          inputRef={register}
                        />
                      </Form.Group>
                      <Form.Group>
                        <SelectInput
                          name="clientEmail"
                          id="clientEmail"
                          value={props.formState.clientEmail}
                          onChange={(e) => handleValueChange('clientEmail', e.target.value)}
                          label="Client Email"
                          selectOptions={clientEmailOption}
                          errors={errors.clientEmail}
                          inputRef={register}
                        />
                      </Form.Group>
                    </React.Fragment>
                    :
                    <React.Fragment>
                      <Form.Group>
                        <TextInput
                          name="clientPhone"
                          id="clientPhone"
                          value={props.formState.clientPhone}
                          onChange={(e) => handleValueChange('clientPhone', e.target.value)}
                          label="Client Phone"
                          errors={errors.clientPhone}
                          inputRef={register}
                          disabled={true}
                        />
                      </Form.Group>
                      <Form.Group>
                        <TextInput
                          name="clientEmail"
                          id="clientEmail"
                          value={props.formState.clientEmail}
                          onChange={(e) => handleValueChange('clientEmail', e.target.value)}
                          label="Client Email"
                          errors={errors.clientEmail}
                          inputRef={register}
                          disabled={true}
                        />
                      </Form.Group>
                    </React.Fragment>
                  }
               </React.Fragment>
              }
              {loading &&
                <Row className="d-flex justify-content-center">
                  <CircularProgress className="mt-5 mb-5" />
                </Row>
              }
              <Row>
                <Col className="text-left pb-3 appointment-back-btn">
                  <Button id="back-button" variant="outlined" className='w-100 back-button' size="large" color="primary" onClick={props.onBack} disabled={loading}>BACK</Button>
                </Col>
                <Col className="pb-3 appointment-cont-btn">
                  <Button id="submit-button" type="submit" variant="contained" className='w-100' size="large" color="primary" disabled={loading || props.roleType == 'operations' || props.roleType == 'non-producing branch manager'}>SUBMIT</Button>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </form>
    </Container>
  )
}

YourInformation.propTypes = {
  formState: PropTypes.object.isRequired,
  onNext: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  onFieldChange: PropTypes.func.isRequired,
};

YourInformation.DefaultFormState = (prefill = false) => {
  return {
    timeZone: (function () {
      const tz = moment.tz.guess();
      const tz1 = timeZones().find(e => e.zone === tz);
      return tz1 ? tz1.value : ''
    })(),
    specificApptDate: '',
    specificApptTime: '',
    specificAppt: 'asap',
    attestation: false,
    advisorPhone:'',
    advPhone: '',
    altPhone: '',
    advisorEmail:'',
    advEmail: '',
    clientPhone:'',
    clientEmail:'',
    caseID: null,
    isQuoteFailure: '',
    referenceID: '',
    morganStanleyTicketErrorMessages: [],
    caseNumber: '',
    altEmail:''
  };
};

YourInformation.ValidationSchema = (isPermIllustration,isIllustration) => {
  return object().shape({
    timeZone: string().transform(emptyStringToUndefined).when('specificAppt', {
      is: 'schedule',
      then: string().required("Timezone is required."),
    }),
    specificApptDate: string().transform(emptyStringToUndefined).when('specificAppt', {
      is: 'schedule',
      then: string().required("Date is required."),
    }),
    specificApptTime: string().when('specificAppt', {
      is: 'schedule',
      then: string().required('Time of call is required.'),
      otherwise: string().notRequired()
    }),
    attestation: !isPermIllustration && !isIllustration ? mixed().oneOf([true], 'This field is required.') : string().notRequired(),
    advPhone: isPermIllustration ? string().required('Advisor Phone is required.') : string().notRequired(),
    altPhone: string().when('advPhone', {
      is: (advPhone) => advPhone === 'altPhone' && isPermIllustration,
      then: string().required('Advisor Phone is required.').matches(/^\(\d{3}\)\s\d{3}-\d{4}$/, 'Phone must be formatted as (123) 456-7890'),
      otherwise: string().notRequired()
    }),
    advEmail: isPermIllustration ? string().nullable().required('Advisor Email is required.') : string().nullable().notRequired(),
    clientPhone:!isPermIllustration && !isIllustration ? string().nullable().required('Client Phone is required.') : string().nullable().notRequired(),
    clientEmail: !isPermIllustration && !isIllustration ? string().nullable().required('Client Email is required.') : string().nullable().notRequired(),
    altEmail : string().when('advEmail',{
      is: (advEmail) => advEmail==='altEmail' && isPermIllustration,
      then : string().email('Email address must be valid.').required('Email address is required.'),
      otherwise : string().notRequired()
    }),
  });
};


// WEBPACK FOOTER //
// ./src/components/Product/SharedComponents/YourInformation/YourInformation.js